import { api } from "./api";

export const getConfigApi = (name) => api.get(`/config/${name}`)